import React from "react";

const AuthDefault = () => {
  return (
    <>
      <h3>What are credentials?</h3>
      Credentials help actions in the integration flows verify and connect with APIs. iHUB provides various authentication methods:
      <ul>
        <li>
          <strong>None:</strong> No credential setup needed. It's the default option.
        </li>
        <li>
          <strong>Atlassian Authorization Token:</strong> Automatically available. Used mainly for internal Jira tasks. Tokens get exchanged during
          app setup.
        </li>
        <li>
          <strong>Basic Auth:</strong> Requires username and password. For Jira-to-Jira interactions, use a username plus Atlassian PAT-tokens.
        </li>
        <li>
          <strong>Bearer Token:</strong> Suitable for systems needing a single token string.
        </li>
        <li>
          <strong>OAuth2:</strong> A common choice for many systems. iHUB supports standard OAuth2 grant types.
        </li>
        <li>
          <strong>JWT:</strong> Another popular option for many systems.
        </li>
        <li>
          <strong>Custom Headers:</strong> Any custom header that the remote system is needed such as Authorization + custom, token or key headers. These will be sent to the remote system as HTTP headers. 
        </li>
      </ul>
    </>
  );
};
export default AuthDefault;
